import { gql } from '@apollo/client';
import { MEDIA_MENU_ITEM_ACTIONS_FRAGMENT } from '~/singlePageApp/screens/ContentLibrary/Media/data/MediaMenuItemActions.gql';

export const MEDIA_FOR_MEDIA_GROUP_FRAGMENT = gql`
  fragment MediaForMediaGroup__Media on Media {
    ...MediaMenuItemActions__Media
    storyboard {
      id
      aspectRatio
      frameCount
      frameWidth
      frameHeight
      height
      url
      width
    }
  }
  ${MEDIA_MENU_ITEM_ACTIONS_FRAGMENT}
`;
